import React from "react";
import { BackgroundPage } from "../../../components";

function RelatorioCashback() {
  const iframeStyle = {
    marginTop: "2px",
    width: "100%",
    height: "calc(100vh - 0px)",
    border: "none",
  };
  const url =
    "https://app.powerbi.com/view?r=eyJrIjoiNDRkYzExYWItY2NjNy00YmM0LWE3ZmItZWEzNzM1MmJjNWExIiwidCI6ImM1YzJhOGM3LWVlNzMtNGUzZS1iM2M0LTdkODdhMjQ4MGEzMyJ9";

  return (
    <BackgroundPage>
      <iframe
        title="cashback-relatorio"
        className="powerbi-iframe"
        style={iframeStyle}
        src={url}
        allowFullScreen={true}
      ></iframe>
    </BackgroundPage>
  );
}

RelatorioCashback.route = "/cashback_relatorio";

export default RelatorioCashback;
